const mv = (v) => `${v >= 0 ? "+" : "-"}$${Math.abs(v).toFixed(2)}`;
const COLS = [["m15", "15 min"], ["h1", "1 hour"], ["h4", "4 hours"]];

const Col = ({ label, s, id }) => (
  <div className="desk-box" data-testid={`desk-ss-${id}`}>
    <div className="k">After {label}</div>
    {!s ? <div className="v text-[color:var(--mute)]">—</div> : (
      <>
        <div className={`v !text-lg sm:!text-xl ${s.avg >= 0 ? "desk-up" : "desk-down"}`}>{mv(s.avg)}</div>
        <div className="text-sm text-[color:var(--mute)] mt-1">typical size ${s.size.toFixed(2)}</div>
        <div className="text-sm text-[color:var(--mute)]">up {s.up_pct}% · {s.n} cases</div>
      </>
    )}
  </div>
);

export const StrikeStats = ({ stats }) => (
  <div className="mt-4" data-testid="desk-strike-stats">
    <div className="text-base font-semibold mb-2">Average gold move after strike headlines</div>
    <div className="grid grid-cols-3 gap-2">{COLS.map(([k, l]) => <Col key={k} label={l} s={stats?.[k]} id={k} />)}</div>
    <p className="text-sm text-[color:var(--mute)] mt-2">
      {stats?.events ? `Based on ${stats.events} strength 4–5 conflict headlines during market hours.` : "Not enough strike headlines during market hours yet."}
      {" "}Small sample: a pattern guide, not a prediction.
    </p>
  </div>
);
